var render, staticRenderFns
import script from "./schemaInfo.vue?vue&type=script&lang=js&"
export * from "./schemaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a26ea7b')) {
      api.createRecord('4a26ea7b', component.options)
    } else {
      api.reload('4a26ea7b', component.options)
    }
    
  }
}
component.options.__file = "src/components/global/schemaInfo.vue"
export default component.exports